import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6 mt-10" }
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = {
  class: "col-lg-8 fv-row border rounded p-4",
  style: {"background":"#f5f5f5","min-height":"200px"},
  dir: "rtl"
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-lg-8 fv-row" }
const _hoisted_29 = { class: "card-title m-0" }
const _hoisted_30 = { class: "fw-bolder m-0" }
const _hoisted_31 = { class: "collapse show" }
const _hoisted_32 = { class: "card-body border-top p-9" }
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_35 = { class: "d-flex col-lg-8 fv-row" }
const _hoisted_36 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitPullFirstButton",
  class: "btn btn-primary flex-shrink-0"
}
const _hoisted_37 = { class: "indicator-label" }
const _hoisted_38 = { class: "indicator-progress" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_40 = { class: "fv-plugins-message-container position-absolute top-10 start-50" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "row mb-6" }
const _hoisted_48 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_49 = { class: "col-lg-8 fv-row" }
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_54 = { class: "col-lg-8 fv-row" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8 fv-row" }
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "card-title m-0" }
const _hoisted_63 = { class: "fw-bolder m-0" }
const _hoisted_64 = { class: "collapse show" }
const _hoisted_65 = { class: "card-body border-top p-9" }
const _hoisted_66 = { class: "row mb-6" }
const _hoisted_67 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_68 = { class: "d-flex col-lg-8 fv-row" }
const _hoisted_69 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitPullSecondButton",
  class: "btn btn-primary flex-shrink-0"
}
const _hoisted_70 = { class: "indicator-label" }
const _hoisted_71 = { class: "indicator-progress" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_73 = { class: "fv-plugins-message-container position-absolute top-10 start-50" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_77 = { class: "col-lg-8 fv-row" }
const _hoisted_78 = { class: "fv-plugins-message-container" }
const _hoisted_79 = { class: "fv-help-block" }
const _hoisted_80 = { class: "row mb-6" }
const _hoisted_81 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_82 = { class: "col-lg-8 fv-row" }
const _hoisted_83 = { class: "fv-plugins-message-container" }
const _hoisted_84 = { class: "fv-help-block" }
const _hoisted_85 = { class: "row mb-6" }
const _hoisted_86 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_87 = { class: "col-lg-8 fv-row" }
const _hoisted_88 = { class: "fv-plugins-message-container" }
const _hoisted_89 = { class: "fv-help-block" }
const _hoisted_90 = { class: "row mb-6" }
const _hoisted_91 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_92 = { class: "col-lg-8 fv-row" }
const _hoisted_93 = { class: "fv-plugins-message-container" }
const _hoisted_94 = { class: "fv-help-block" }
const _hoisted_95 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_96 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_97 = { class: "indicator-label" }
const _hoisted_98 = { class: "indicator-progress" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_MonacoEditor = _resolveComponent("MonacoEditor")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'newsletter'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateNewsletterSection')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.newslettersSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('title')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "title",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('title'),
                      modelValue: _ctx.newsletter.title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newsletter.title) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "title" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('key')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "key",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('key'),
                      modelValue: _ctx.newsletter.key,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newsletter.key) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "key" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('htmlContent')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_MonacoEditor, {
                      language: "json",
                      theme: "vs-dark",
                      class: "w-100",
                      style: {"height":"400px"},
                      value: _ctx.newsletter.htmlContent,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newsletter.htmlContent) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "htmlContent" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('htmlPreview')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", { innerHTML: _ctx.htmlContentPreview }, null, 8, _hoisted_25)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.translate('sort')), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_Field, {
                      name: "sort",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      modelValue: _ctx.newsletter.sort,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newsletter.sort) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.translate('pullFirstArticle')), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_Form, {
                    class: "form",
                    onSubmit: _ctx.onSubmitPullFirstArticle
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.translate('url')), 1),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "link1",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid me-3",
                              placeholder: _ctx.translate('url'),
                              modelValue: _ctx.newsletter.link1,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newsletter.link1) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("button", _hoisted_36, [
                              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.translate('pullData')), 1),
                              _createElementVNode("span", _hoisted_38, [
                                _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                                _hoisted_39
                              ])
                            ], 512)
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_ErrorMessage, { name: "link1" })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.translate('title')), 1),
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "title",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('title'),
                              modelValue: _ctx.news1.title,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.news1.title) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createVNode(_component_ErrorMessage, { name: "title" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.translate('description')), 1),
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_Field, {
                              as: "textarea",
                              name: "description",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('description'),
                              modelValue: _ctx.news1.description,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.news1.description) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(_component_ErrorMessage, { name: "description" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.translate('image')), 1),
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "image",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('image'),
                              modelValue: _ctx.news1.image,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.news1.image) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _createVNode(_component_ErrorMessage, { name: "image" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('section')), 1),
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "section",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('section'),
                              modelValue: _ctx.news1.section,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.news1.section) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _createVNode(_component_ErrorMessage, { name: "section" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("h3", _hoisted_63, _toDisplayString(_ctx.translate('pullSecondArticle')), 1)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_Form, {
                    class: "form",
                    onSubmit: _ctx.onSubmitPullSecondArticle
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.translate('url')), 1),
                          _createElementVNode("div", _hoisted_68, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "link2",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid me-3",
                              placeholder: _ctx.translate('url'),
                              modelValue: _ctx.newsletter.link2,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newsletter.link2) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("button", _hoisted_69, [
                              _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.translate('pullData')), 1),
                              _createElementVNode("span", _hoisted_71, [
                                _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                                _hoisted_72
                              ])
                            ], 512)
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createVNode(_component_ErrorMessage, { name: "link2" })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.translate('title')), 1),
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "title",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('title'),
                              modelValue: _ctx.news2.title,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.news2.title) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("div", _hoisted_79, [
                                _createVNode(_component_ErrorMessage, { name: "title" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.translate('description')), 1),
                          _createElementVNode("div", _hoisted_82, [
                            _createVNode(_component_Field, {
                              as: "textarea",
                              name: "description",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('description'),
                              modelValue: _ctx.news2.description,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.news2.description) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                _createVNode(_component_ErrorMessage, { name: "description" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.translate('image')), 1),
                          _createElementVNode("div", _hoisted_87, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "image",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('image'),
                              modelValue: _ctx.news2.image,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.news2.image) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("div", _hoisted_89, [
                                _createVNode(_component_ErrorMessage, { name: "image" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.translate('section')), 1),
                          _createElementVNode("div", _hoisted_92, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "section",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('section'),
                              modelValue: _ctx.news2.section,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.news2.section) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_93, [
                              _createElementVNode("div", _hoisted_94, [
                                _createVNode(_component_ErrorMessage, { name: "section" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ])
              ]),
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'newsletter'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_96, [
                      _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_98, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_99
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}